<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="!page.isNew && $check(['financial.view'])" type="button" elevation="0" color="primary" outlined
                            :to="`/financeiro/veiculos/${$route.params.id}`">
                            <v-icon left small>mdi-cash-multiple</v-icon>Custos
                        </v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataset.loading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataset.loading" v-if="!page.isNew">Atualizar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/veiculos">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <!-- <v-card-title class="card-group-title">{{ page.title }}</v-card-title> -->
                                <v-card-text>

                                    <v-row>
                                        <v-col cols="12" md="5">
                                            <v-autocomplete dense id="brand" :items="dataset.brands" label="Marca"
                                                v-model="dataset.brandId" item-value="id" item-text="name" outlined
                                                hide-details="auto" :rules="[$rules.required]"
                                                no-data-text="Nenhuma marca cadastrada" @change="onBrandChange"
                                                append-outer-icon="mdi-plus-circle-outline"
                                                @click:append-outer="openCatalog('brand')">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-autocomplete dense id="model" :items="brandModels" label="Modelo"
                                                v-model="dataset.data.vehicle_model_id" item-value="id"
                                                item-text="model" outlined hide-details="auto"
                                                :rules="[$rules.required]" :disabled="!dataset.brandId"
                                                :no-data-text="dataset.brandId ? 'Nenhum modelo nesta marca' : 'Escolha a marca primeiro'"
                                                append-outer-icon="mdi-plus-circle-outline"
                                                @click:append-outer="dataset.brandId && openCatalog('model')">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-select dense outlined label="Câmbio" :items="dataset.transmissions"
                                                v-model="dataset.data.transmission" hide-details="auto" clearable>
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="4">
                                            <v-text-field dense id="plate" label="Placa" v-model="dataset.data.plate"
                                                hide-details="auto" outlined :rules="[$rules.required]"
                                                required></v-text-field>
                                        </v-col>

                                        <v-col cols="4">
                                            <v-select style="padding-left: 4px;" dense id="color"
                                                :items="dataset.vehicleColorTypesData" label="Cor"
                                                v-model="dataset.data.vehicle_color_id" item-value="id" item-text="name"
                                                outlined hide-details="auto" :rules="[$rules.required]" required>
                                            </v-select>

                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field dense id="year" label="Ano" type="number"
                                                v-model="dataset.data.year" hide-details="auto" outlined required
                                                :rules="[$rules.required, v => (v && v.toString().length === 4) || 'O ano deve ter somente 4 dígitos']"></v-text-field>

                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field dense id="code" label="Frota" v-model="dataset.data.code"
                                                hide-details="auto" outlined :rules="[$rules.required]" required>
                                            </v-text-field>
                                        </v-col>

                                        <v-col cols="6">
                                            <v-text-field dense id="chassi" label="Chassi" v-model="dataset.data.chassi"
                                                hide-details="auto" outlined :rules="[$rules.required]" required>
                                            </v-text-field>

                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="6">
                                            <v-select dense outlined label="Tipo de combustível"
                                                :items="dataset.fuelTypes" v-model="dataset.data.fuel_type"
                                                hide-details="auto" clearable></v-select>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field dense outlined type="number"
                                                label="Margem de odômetro entre abastecimentos" suffix="KM"
                                                v-model="dataset.data.fuel_odometer_margin" min="0"
                                                hide-details="auto"></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="6">
                                            <v-file-input dense outlined show-size counter label="Foto do veículo"
                                                v-model="dataset.data.image" accept="image/png, image/jpeg, image/bmp"
                                                placeholder="Selecione a foto do veículo" prepend-icon="mdi-camera"
                                                hide-details="auto"></v-file-input>

                                            <div v-if="dataset.data.image_id">
                                                <private-image :id="dataset.data.image_id" :size="100"></private-image>
                                                <v-btn small text color="red" @click="removeImage">Remover Foto
                                                    Atual</v-btn>
                                            </div>
                                        </v-col>
                                    </v-row>



                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

        <vehicle-catalog-dialog v-model="catalog.open" :kind="catalog.kind" :brands="dataset.brands"
            :brand-id="dataset.brandId" @saved="onCatalogSaved" />

    </v-container>
</template>

<script>
import string from "@/common/util/string"
import object from "@/common/util/object"

import axios from "axios"
import vehicleColorTypesData from '@/common/data/vehicle-color-types.data';
import vehicleCarMakesData from '@/common/data/vehicle-car-makes.data';
import vehicleCarModelsData from '@/common/data/vehicle-car-models.data';
import VehicleCatalogDialog from '@/layouts/components/vehicle/VehicleCatalogDialog.vue';

export default {
    name: "VehicleDetails",

    components: { VehicleCatalogDialog },

    data: () => ({
        page: {
            title: "",
            isNew: true
        },
        dataset: {
            data: {},
            models: [],
            brands: [],
            brandId: null,
            transmissions: [
                { value: 'manual', text: 'Manual' },
                { value: 'automatic', text: 'Automático' },
            ],
            breadcrumbItems: [],
            loading: false,
            vehicleColorTypesData,
            vehicleCarMakesData,
            vehicleCarModelsData,
            fuelTypes: ['Gasolina', 'Etanol', 'Diesel', 'GNV', 'Flex'],
        },
        dataForm: {
            validForm: true,
        },
        catalog: {
            open: false,
            kind: 'brand',
        },

        imageRules: [
            v => !v || v.size < 2000000 || 'A imagem deve ser menor que 2 MB',
            v => !v || ['image/jpeg', 'image/png', 'image/bmp'].includes(v.type) || 'Formato de imagem inválido (JPEG, PNG, BMP)'
        ],
    }),

    created() {
        this.loadData()
    },

    computed: {
        brandModels() {
            return this.dataset.models.filter((item) => item.brand_id === this.dataset.brandId)
        },
    },

    methods: {
        loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            this.loadVehicleModels();

            if (!this.page.isNew) {
                this.loadVehicleDetails();
            }
        },

        goBack() {
            this.$router.replace("/veiculos");
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? "Novo veículo" : "Editar veículo";
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Veículos",
                disabled: false,
                to: "/veiculos",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? "Novo veículo" : "Editar veículo",
                disabled: true,
                exact: true,
            });
        },

        async loadVehicleDetails() {
            if (this.page.isNew) return;

            this.dataset.loading = true;
            try {
                const vehicleId = this.$route.params.id;
                const result = await axios.get(`/api/v2/vehicles/${vehicleId}`);

                this.dataset.data = result.data.content.data;
                this.syncBrand();
            } catch (error) {
                this.$dialog.notify.error('Ocorreu um erro ao carregar os detalhes do veículo. Tente novamente!', {
                    position: 'top-right',
                    timeout: 2000
                });
                console.error("Erro ao carregar detalhes do veículo:", error);
            } finally {
                this.dataset.loading = false;
            }
        },

        async loadVehicleModels() {
            this.dataset.loading = true;
            try {
                const [brands, models] = await Promise.all([
                    axios.get('/api/v2/vehicle-brands'),
                    axios.get('/api/v2/vehicle-models'),
                ]);

                this.dataset.brands = brands.data.content;
                this.dataset.models = models.data.content;
                this.syncBrand();
            } catch (error) {
                this.$dialog.notify.error('Ocorreu um erro ao carregar os modelos de veículos. Tente novamente!', {
                    position: 'top-right',
                    timeout: 2000
                });
                console.error("Erro ao carregar detalhes do veículo:", error);
            } finally {
                this.dataset.loading = false;
            }
        },


        // Marca vem do modelo do veículo
        syncBrand() {
            const model = this.dataset.models.find((item) => item.id === this.dataset.data.vehicle_model_id);
            if (model) this.dataset.brandId = model.brand_id;
        },

        onBrandChange() {
            const model = this.dataset.models.find((item) => item.id === this.dataset.data.vehicle_model_id);
            if (!model || model.brand_id !== this.dataset.brandId) {
                this.$set(this.dataset.data, 'vehicle_model_id', null);
            }
        },

        openCatalog(kind) {
            this.catalog = { open: true, kind };
        },

        onCatalogSaved(item) {
            if (this.catalog.kind === 'brand') {
                this.dataset.brands = [...this.dataset.brands, { ...item, models_count: 0 }]
                    .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));
                this.dataset.brandId = item.id;
                this.$set(this.dataset.data, 'vehicle_model_id', null);
                return;
            }
            this.dataset.models = [...this.dataset.models, item];
            this.dataset.brandId = item.brand_id;
            this.$set(this.dataset.data, 'vehicle_model_id', item.id);
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja salvar o veículo?',
                title: 'Salvar veículo',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            let payload = this.buildPayload();

            try {
                if (this.dataset.data.image) {
                    const formData = new FormData()
                    formData.append('file', this.dataset.data.image);

                    const responseResource = await axios.post(`/api/v2/resources`, formData);

                    payload.image_id = responseResource.data.content.id;
                }

                await axios.post(`/api/v2/vehicles`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Veículo salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o veículo?',
                title: 'Atualizar veículo',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;


            try {
                if (this.dataset.data.image) {
                    const formData = new FormData()
                    formData.append('file', this.dataset.data.image);

                    const responseResource = await axios.post(`/api/v2/resources`, formData);

                    this.dataset.data.image_id = responseResource.data.content.id;
                }

                let payload = this.buildPayload();

                await axios.patch(`/api/v2/vehicles/${this.$route.params.id}`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Veículo salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async removeImage() {
            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja remover a imagem do veículo?',
                title: 'Remover',
                actions: {
                    false: 'Cancelar',
                    true: 'Remover'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            try {
                await axios.delete(`/api/v2/vehicles/${this.$route.params.id}/image`);

                this.$dialog.notify.info("Imagem removida com sucesso", { position: "top-right", timeout: 2000 });

                await this.loadData()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        buildPayload() {

            let data = {
                plate: this.dataset.data.plate,
                vehicle_color_id: this.dataset.data.vehicle_color_id,
                vehicle_model_id: this.dataset.data.vehicle_model_id,
                chassi: this.dataset.data.chassi,
                code: this.dataset.data.code,
                year: this.dataset.data.year,
                image_id: this.dataset.data.image_id,
                fuel_type: this.dataset.data.fuel_type || null,
                transmission: this.dataset.data.transmission || null,
                fuel_odometer_margin: this.dataset.data.fuel_odometer_margin
                    ? Number(this.dataset.data.fuel_odometer_margin)
                    : null,
            }


            return data;
        },

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>
